import React, { Component } from 'react';
import config from 'react-global-configuration';
import RequestApi from '../../Miscelania/RequestApi';

import { Modal } from 'react-bootstrap';

// Helpers de formulário
import Select from 'react-select';
import InputMask from 'react-input-mask';
import getLocale from '../../../i18n/getLocale';

class FlightReportStaffsTab extends Component {
  constructor(props) {
    super(props);

    this.state = {
      overlay: {
        message: '',
        type: '',
        status: 'closed',
      },
      redirect_url: false,
      loaded: false,
      modal_edit: false,
      flight_report_id: null,
      staff_id: null,
      duty_id: null,
      arrival: null,
      date: this.props.flight_report.date_str,
      flight_report: this.props.flight_report,
      flight_report_staffs: this.props.flight_report_staffs,
      staffs_select: [],
      duties_select: [],
    };

    this.add = this.add.bind(this);
    this.edit = this.edit.bind(this);
    this.deleteStaff = this.deleteStaff.bind(this);
    this.openModal = this.openModal.bind(this);

    // Handlers
    this.locale = getLocale();

  }
  // Handlers
  handleSelectChange(name, event) {
    var change = {};
    if(event == null) {
      change[name] = null;
    } else {
      change[name] = event.value;
    }
    this.setState(change);
  }
  handleChange (name, event) {
    var change = {};
    change[name] = event.target.value;
    this.setState(change);
  }
  // LM
  componentWillReceiveProps(newProps) {
    if(Array.isArray(newProps.flight_report_staffs) || (this.state.loaded === 1 && newProps.updated === 1)) {
      this.setState({
        flight_report_id: newProps.flight_report_id,
        flight_report_staffs: newProps.flight_report_staffs,
        staffs_select: newProps.staffs_select,
        duties_select: newProps.duties_select,
        flight_report: newProps.flight_report,
        date: newProps.flight_report.date_str,
        loaded: 1,
      });
    }
  }

  openModal(flight_report_leg_staff) {

    var arrival = flight_report_leg_staff.arrival;
    let date = arrival.slice(0,10);
    let arrival_hour = arrival.slice(11,16);

    this.setState({
      staff_id: flight_report_leg_staff.staff_id,
      duty_id: flight_report_leg_staff.duty_id,
      date: date,
      arrival_hour: arrival_hour,
      modal_edit: true
    });
  }

  add (event) {
    event.preventDefault();
    this.props.handleAlert('', '', 'open');
    let arrival = this.state.date + ' ' + this.state.arrival_hour;
    var datasave = {
      flight_report_id: this.state.flight_report_id,
      staff_id: this.state.staff_id,
      duty_id: this.state.duty_id,
      arrival: arrival,
    };
    var header = this.refs.request_api.header('application/json');
    var self = this;
    Promise.resolve(header).then(function(value) {
      fetch(config.get('api') + '/relatorio/voo/tripulante', { method: 'POST', mode: 'cors', headers: value, body: JSON.stringify(datasave) }).then((response) => response.json()).catch((error) => { console.error(error); }).then((responseJson) => {
        self.refs.request_api.validate(responseJson, 'alert');
        self.props.updateData(responseJson);
        self.setState({staff_id: null, duty_id: null});
      }).catch((error) => {
        console.error(error);
      });
    });
  }

  edit (event) {
    event.preventDefault();
    this.props.handleAlert('', '', 'open');
    let arrival = this.state.date + ' ' + this.state.arrival_hour;
    var datasave = {
      flight_report_id: this.state.flight_report_id,
      staff_id: this.state.staff_id,
      duty_id: this.state.duty_id,
      arrival: arrival,
    };
    var header = this.refs.request_api.header('application/json');
    var self = this;
    Promise.resolve(header).then(function(value) {
      fetch(config.get('api') + '/relatorio/voo/tripulante', { method: 'PUT', mode: 'cors', headers: value, body: JSON.stringify(datasave) }).then((response) => response.json()).catch((error) => { console.error(error); }).then((responseJson) => {
        self.refs.request_api.validate(responseJson, 'alert');
        self.props.updateData(responseJson);
        self.setState({staff_id: null, duty_id: null, modal_edit: false});
      }).catch((error) => {
        console.error(error);
      });
    });
  }

  deleteStaff (staff_id) {
    if (window.confirm(this.locale.RelatoriosDeVoo.EditarRelatoriosDeVoo.excluirTripulante)) {
      this.props.handleAlert('', '', 'open');
      var datasave = {
        staff_id: staff_id,
        flight_report_id: this.state.flight_report_id,
      };
      var header = this.refs.request_api.header('application/json');
      var self = this;
      Promise.resolve(header).then(function(value) {
        fetch(config.get('api') + '/relatorio/voo/tripulante', { method: 'DELETE', mode: 'cors', headers: value, body: JSON.stringify(datasave) }).then((response) => response.json()).catch((error) => { console.error(error); }).then((responseJson) => {
          self.refs.request_api.validate(responseJson, 'alert');
          self.props.updateData(responseJson);
        }).catch((error) => {
          console.error(error);
        });
      });
    }
  }

  render() {
    var self = this;
    return (
<div>
  <RequestApi ref={'request_api'} />
  <h3 className="page-title">{this.locale.RelatoriosDeVoo.EditarRelatoriosDeVoo.tituloCadastrarTripulacao}</h3>
  <hr/>
  <form onSubmit={this.add}>
    <div className="row">
      <div className="col-md-3 form-group">
        <label>{this.locale.RelatoriosDeVoo.EditarRelatoriosDeVoo.formularioCadastrarTripulacao.Tripulante}:</label>
        <Select
          className="form-field-name"
          name="staff_id"
          value={this.state.staff_id}
          searchable={true}
          placeholder={''}
          onChange={this.handleSelectChange.bind(this, 'staff_id')}
          options={this.state.staffs_select}
          required
        />
      </div>
      <div className="col-md-3 form-group">
        <label>{this.locale.RelatoriosDeVoo.EditarRelatoriosDeVoo.formularioCadastrarTripulacao.FuncaoDeBordo}:</label>
        <Select
          className="form-field-name"
          name="duty_id"
          value={this.state.duty_id}
          searchable={true}
          placeholder={''}
          onChange={this.handleSelectChange.bind(this, 'duty_id')}
          options={this.state.duties_select}
          required
        />
      </div>
      <div className="col-md-3 form-group">
        <label>{this.locale.RelatoriosDeVoo.EditarRelatoriosDeVoo.formularioCadastrarTripulacao.DataDeApresentacao}:</label>
        <InputMask value={this.state.date}  maskChar={null} name="arrival" mask="99/99/9999" className="form-control" onChange={this.handleChange.bind(this, 'date')} placeholder={this.locale.general.diaMesAno} required />
      </div>
      <div className="col-md-3 form-group">
        <label>{this.locale.RelatoriosDeVoo.EditarRelatoriosDeVoo.formularioCadastrarTripulacao.HoraDeApresentacao}:</label>
        <InputMask value={this.state.arrival_hour}  maskChar={null} name="arrival" mask="99:99" className="form-control" onChange={this.handleChange.bind(this, 'arrival_hour')} placeholder={this.locale.general.horaMinuto} required />
      </div>
    </div>
    <hr/>
    <button type="submit" className="btn btn-primary btn-lg btn-block"><i className="fa fa-fw fa-save"></i> {this.locale.RelatoriosDeVoo.EditarRelatoriosDeVoo.formularioCadastrarTripulacao.botaoAdicionarTripulante}</button>
  </form>
  <hr/>
  <h4 className="page-title">{this.locale.RelatoriosDeVoo.EditarRelatoriosDeVoo.tituloTripulantesCadastrados}</h4>
  <hr/>
  <div className="table-responsive">
    <table className="table table-bordered table-hover table-striped">
      <thead>
        <tr>
          <th style={{width: '380px'}}>{this.locale.RelatoriosDeVoo.EditarRelatoriosDeVoo.tabelaTripulantesCadastrados.Nome}</th>
          <th>{this.locale.RelatoriosDeVoo.EditarRelatoriosDeVoo.tabelaTripulantesCadastrados.CANAC}</th>
          <th>{this.locale.RelatoriosDeVoo.EditarRelatoriosDeVoo.tabelaTripulantesCadastrados.SISPAT}</th>
          <th>{this.locale.RelatoriosDeVoo.EditarRelatoriosDeVoo.tabelaTripulantesCadastrados.FB}</th>
          <th>{this.locale.RelatoriosDeVoo.EditarRelatoriosDeVoo.tabelaTripulantesCadastrados.Apresentacao}</th>
          <th>{this.locale.RelatoriosDeVoo.EditarRelatoriosDeVoo.tabelaTripulantesCadastrados.DecolagemPouso}</th>
          <th>{this.locale.RelatoriosDeVoo.EditarRelatoriosDeVoo.tabelaTripulantesCadastrados.TempoTotal}</th>
          <th>{this.locale.RelatoriosDeVoo.EditarRelatoriosDeVoo.tabelaTripulantesCadastrados.Navegacao}</th>
          <th>{this.locale.RelatoriosDeVoo.EditarRelatoriosDeVoo.tabelaTripulantesCadastrados.Instrumento}</th>
          <th>{this.locale.RelatoriosDeVoo.EditarRelatoriosDeVoo.tabelaTripulantesCadastrados.Noturno}</th>
          <th>{this.locale.RelatoriosDeVoo.EditarRelatoriosDeVoo.tabelaTripulantesCadastrados.PousosDiurnos}</th>
          <th>{this.locale.RelatoriosDeVoo.EditarRelatoriosDeVoo.tabelaTripulantesCadastrados.PousosNoturnos}</th>
          <th>{this.locale.RelatoriosDeVoo.EditarRelatoriosDeVoo.tabelaTripulantesCadastrados.Pax}</th>
          <th>{this.locale.RelatoriosDeVoo.EditarRelatoriosDeVoo.tabelaTripulantesCadastrados.Carga}</th>
          <th>{this.locale.RelatoriosDeVoo.EditarRelatoriosDeVoo.tabelaTripulantesCadastrados.Consumo}</th>
          <th>{this.locale.RelatoriosDeVoo.EditarRelatoriosDeVoo.tabelaTripulantesCadastrados.LongLine}</th>
          <th>{this.locale.RelatoriosDeVoo.EditarRelatoriosDeVoo.tabelaTripulantesCadastrados.ShortLine}</th>
          <th>{this.locale.RelatoriosDeVoo.EditarRelatoriosDeVoo.tabelaTripulantesCadastrados.Acoes}</th>
        </tr>
      </thead>
      <tbody>
      {Object.keys(self.state.flight_report_staffs).map(function(k) {
        var srls = self.state.flight_report_staffs[k];
        return (
          <tr>
            <td style={{width: '380px'}}>{srls.staff}</td>
            <td>{srls.canac}</td>
            <td>{srls.sispat}</td>
            <td>{srls.duty}</td>
            <td>{srls.arrival}</td>
            <td>{srls.takeoff_land_time_total}</td>
            <td>{srls.time_total}</td>
            <td>{srls.navigation_total}</td>
            <td>{srls.ifr_total}</td>
            <td>{srls.night_total}</td>
            <td>{srls.day_landings_total}</td>
            <td>{srls.night_landings_total}</td>
            <td>{srls.pax_total}</td>
            <td>{srls.payload_total}</td>
            <td>{srls.fuel_total}</td>
            <td>{srls.long_line_total}</td>
            <td>{srls.short_line_total}</td>
            <td style={{width: '100px', whiteSpace: 'nowrap', textAlign: 'center'}}>
              <button onClick={() => self.openModal(srls)} className="btn btn-primary btn-sm button-inline"><i className="fa fa-pencil"></i></button>
              <button onClick={() => self.deleteStaff(srls.staff_id)} className="btn btn-danger btn-sm button-inline"><i className="fa fa-trash"></i></button>
            </td>
          </tr>
        );
      })}
      </tbody>
    </table>
  </div>
  <Modal show={this.state.modal_edit} aria-labelledby="contained-modal-title-lg" bsSize={'large'}>
    <Modal.Header>
      <h4 className="pull-left">{this.locale.RelatoriosDeVoo.EditarRelatoriosDeVoo.modalEditarTripulacao.Titulo}</h4>
      <button className="btn btn-danger btn-sm pull-right" onClick={() => self.setState({modal_edit: false})}>
      <i className="fa fa-fw fa-close"></i></button>
      <div className="clearfix"></div>
    </Modal.Header>
    <Modal.Body>
      <form onSubmit={this.edit}>
        <div className="row">
          <div className="col-md-4 form-group">
            <label>{this.locale.RelatoriosDeVoo.EditarRelatoriosDeVoo.modalEditarTripulacao.FuncaoDeBordo}:</label>
            <Select
              className="form-field-name"
              name="duty_id"
              value={this.state.duty_id}
              searchable={true}
              placeholder={''}
              onChange={this.handleSelectChange.bind(this, 'duty_id')}
              options={this.state.duties_select}
              required
            />
          </div>
          <div className="col-md-4 form-group">
            <label>{this.locale.RelatoriosDeVoo.EditarRelatoriosDeVoo.modalEditarTripulacao.DataDeApresentacao}:</label>
            <InputMask value={this.state.date}  maskChar={null} name="arrival" mask="99/99/9999" className="form-control" onChange={this.handleChange.bind(this, 'date')} placeholder={this.locale.general.diaMesAno} required />
          </div>
          <div className="col-md-4 form-group">
            <label>{this.locale.RelatoriosDeVoo.EditarRelatoriosDeVoo.modalEditarTripulacao.HoraDeApresentacao}:</label>
            <InputMask value={this.state.arrival_hour}  maskChar={null} name="arrival" mask="99:99" className="form-control" onChange={this.handleChange.bind(this, 'arrival_hour')} placeholder={this.locale.general.horaMinuto} required />
          </div>
        </div>
        <hr/>
        <button type="submit" className="btn btn-primary btn-lg btn-block"><i className="fa fa-fw fa-save"></i> {this.locale.RelatoriosDeVoo.EditarRelatoriosDeVoo.modalEditarTripulacao.botaoEditarTripulante}</button>
      </form>          
    </Modal.Body>
    <Modal.Footer>
      <button className="btn btn-danger btn-sm pull-right" onClick={() => {this.setState({modal_edit: false})}}>
      <i className="fa fa-fw fa-close"></i></button>
    </Modal.Footer>
  </Modal>
</div>
    );
  }
}

export default FlightReportStaffsTab;



// WEBPACK FOOTER //
// ./src/Components/FlightReports/Elements/FlightReportStaffsTab.js